import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#82318e',
                secondary: '#b0bec5',
                accent: '#9f8027',
                error: '#b71c1c',
            },
        },
    },
    breakpoint: {
        mobileBreakpoint: 'sm',
    },
})
